import { render, staticRenderFns } from "./NFTWallet.vue?vue&type=template&id=72fc1388&"
import script from "./NFTWallet.vue?vue&type=script&lang=ts&"
export * from "./NFTWallet.vue?vue&type=script&lang=ts&"
import style0 from "./NFTWallet.vue?vue&type=style&index=0&id=72fc1388&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports